/**
 * Traffickong, `/postbacks/traffickong`. Generic PostbackQueryDto; the
 * controller doc comment notes Traffickong maps `ui=clickid`. Backoffice, TMA
 * and Telegram agree on this template verbatim.
 */
export const traffickongContract = {
    id: 'traffickong',
    displayName: 'Traffickong',
    route: 'traffickong',
    trackingTagMacro: '{clickid}',
    amountBehavior: 'amount comes from {payout} on FTD/CPA. currency is not a Traffickong macro; CPA hardcodes EUR.',
    duplicateParamPolicy: 'array-then-tolerant-last-wins',
    caseSensitiveParams: [],
    requiresFixedCurrencyForCpa: true,
    pitfalls: ['Traffickong maps ui=clickid on their side; our uid= always carries {clickid}.'],
    sourceRefs: ['apps/api/src/modules/postbacks/controllers/postbacks.controller.ts:343-381'],
    events: [
        {
            event: 'REG',
            eventValue: 'registration',
            params: [
                { ourParam: 'uid', macro: '{clickid}' },
                { ourParam: 'subid', macro: '{subid}' },
                { ourParam: 'tracking_tag', macro: '{clickid}' },
            ],
        },
        {
            event: 'FTD',
            eventValue: 'ftd',
            params: [
                { ourParam: 'uid', macro: '{clickid}' },
                { ourParam: 'subid', macro: '{subid}' },
                { ourParam: 'amount', macro: '{payout}' },
                { ourParam: 'tracking_tag', macro: '{clickid}' },
            ],
        },
        {
            event: 'QUALIFIED_CPA',
            eventValue: 'cpa',
            params: [
                { ourParam: 'uid', macro: '{clickid}' },
                { ourParam: 'subid', macro: '{subid}' },
                { ourParam: 'amount', macro: '{payout}' },
                { ourParam: 'currency', macro: 'EUR' },
                { ourParam: 'tracking_tag', macro: '{clickid}' },
            ],
            fixedParams: { currency: 'EUR' },
        },
    ],
};
//# sourceMappingURL=traffickong.js.map